import { serializeJsonLd } from '../utils/serialize-json-ld.util';

type JsonLdScriptProps = {
  data: unknown;
};

export const JsonLdScript = ({ data }: JsonLdScriptProps) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: serializeJsonLd(data),
    }}
  />
);
